import { matchPath } from 'react-router-dom';
import { ROUTER_ENTITY_TO_ROUTE_PATH_MAP } from '../../constants';

export const routingFromGeoEvent = (fromRoute: string): boolean => {
  const match = matchPath(fromRoute, {
    path: ROUTER_ENTITY_TO_ROUTE_PATH_MAP.wildfire,
    exact: true,
  });
  return Boolean(match);
};
